import { Space } from "antd";
import { PageTypes } from "enums/pageTypes";
import { TaskStatuses } from "enums/taskStatuses";
import { usePageType } from "hooks/usePageType";
import type React from "react";
import { ApproveButton } from "./components/ApproveButton";
import { PublishButton } from "./components/PublishButton";
import { RecallButton } from "./components/RecallButton";
import { RejectButton } from "./components/RejectButton";
import { ReviewButton } from "./components/ReviewButton";
import { SubmitButton } from "./components/SubmitButton";

type Props = {
  entityId: string;
  season?: any;
  fixture?: any;
  roster: Array<any>;
  staff: Array<any>;
};

export const TaskActions: React.FC<Props> = ({ entityId, season, fixture, roster, staff }: Props) => {
  const pageType = usePageType();

  if (!season && !fixture) {
    return null;
  }

  const taskStatus = season?.taskStatus || fixture?.taskStatus;

  // For fixture roster/staff
  if (fixture) {
    if (pageType === PageTypes.Admin) {
      if (taskStatus === TaskStatuses.SUBMITTED) {
        return (
          <Space>
            <RejectButton entityId={entityId} season={season} fixture={fixture} />
            <PublishButton entityId={entityId} season={season} fixture={fixture} />
          </Space>
        );
      } else if ([TaskStatuses.APPROVED, TaskStatuses.REVIEW].includes(taskStatus)) {
        return <PublishButton entityId={entityId} season={season} fixture={fixture} />;
      }
    } else if (pageType === PageTypes.TeamManager) {
      if ([TaskStatuses.DRAFT, TaskStatuses.REJECTED].includes(taskStatus)) {
        return <SubmitButton entityId={entityId} season={season} fixture={fixture} roster={roster} staff={staff} />;
      } else if (taskStatus === TaskStatuses.SUBMITTED) {
        return (
          <Space>
            <RecallButton entityId={entityId} season={season} fixture={fixture} />
            <PublishButton entityId={entityId} season={season} fixture={fixture} />
          </Space>
        );
      } else if (taskStatus === TaskStatuses.APPROVED) {
        return <PublishButton entityId={entityId} season={season} fixture={fixture} />;
      }
    }

    return;
  }

  // For season roster/staff
  if (pageType === PageTypes.Admin) {
    if (taskStatus === TaskStatuses.SUBMITTED) {
      return <ReviewButton entityId={entityId} season={season} fixture={fixture} />;
    } else if (taskStatus === TaskStatuses.REVIEW) {
      return (
        <Space>
          <RejectButton entityId={entityId} season={season} fixture={fixture} />
          <ApproveButton entityId={entityId} season={season} fixture={fixture} />
        </Space>
      );
    } else if (taskStatus === TaskStatuses.APPROVED) {
      return <PublishButton entityId={entityId} season={season} fixture={fixture} />;
    }
  } else if (pageType === PageTypes.TeamManager) {
    if ([TaskStatuses.DRAFT, TaskStatuses.REJECTED].includes(taskStatus)) {
      return <SubmitButton entityId={entityId} season={season} fixture={fixture} roster={roster} staff={staff} />;
    } else if (taskStatus === TaskStatuses.SUBMITTED) {
      return <RecallButton entityId={entityId} season={season} fixture={fixture} />;
    }
  }
};
